import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

 const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: "/",
      name: "homePage",
      component: () => import("../pages/homePage.vue")
    },
    {
      path: "/submitPhone/:id",
      name: "submitPhone",
      component: () => import("../pages/submitPhone.vue")
    },
    {
      path: "/success",
      name: "success",
      component: () => import("../pages/success.vue")
    },
    {
      path: "/epidemicSuccess",
      name: "epidemicSuccess",
      component: () => import("../pages/epidemicSuccess.vue")
    },
    {
      path: "/huawei_epidemic",
      name: "huawei_epidemic",
      component: () => import("../pages/epidemic.vue")
    },
    {
      path: '/jiaoyu',
      name: 'jiaoyu',
      component: () => import('../pages/jiaoyu.vue')
    },
    {
      path: '/dianshang',
      name: 'dianshang',
      component: () => import('../pages/dianshang.vue')
    },
    {
      path: '/yiwise',
      name: 'yiwise',
      component: () => import('../pages/yiwise.vue')
    },
    {
      path: '/robot',
      name: 'robot',
      component: () => import('../pages/robot.vue')
    },
    {
      path: "/custom_robot",
      name: "custom_robot",
      component: () => import("../pages/customRobot.vue")
    },
    {
      path: "/custom_robot_without_voice",
      name: "custom_robot_without_voice",
      component: () => import("../pages/customRobot.vue"),
      props: {
        noVoice: true
      }
    },
    {
      path: "/callout",
      name: "callout",
      component: () => import("../pages/callout.vue")
    },
    {
      path: "/experience",
      name: "homePage",
      component: () => import("../pages/homePage.vue")
    },
  ]
});

router.beforeEach((to, from, next) => {
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js